import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunPayChannel, deleteBairunPayChannel as _deleteBairunPayChannel, deleteBairunPayChannelByIds, updateBairunPayChannel, findBairunPayChannel, getBairunPayChannelList } from '@/api/bairun/bairunPayChannel'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'BairunPayChannel',
  filters: {
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSupportSourceName: function getSupportSourceName(supportSource) {
      var s = [];
      supportSource && supportSource.split(',').forEach(function (item) {
        if (item === '-1') {
          s.push('全部');
        } else {
          var temp = _this.supportSourceOption.filter(function (item2) {
            return item2.value === supportSource;
          });

          if (temp.length > 0) {
            s.push(temp[0].label);
          }
        }
      });
      return s.join(',');
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getBairunPayChannelList,
      dialogFormVisible: false,
      type: '',
      tableData: {
        all: [],
        show: []
      },
      multipleSelection: [],
      supportSourceOption: [{
        label: '收银端结算',
        value: 'cashier-settle'
      }, {
        label: '收银端充值',
        value: 'cashier-recharge'
      }, {
        label: '收银端过磅',
        value: 'cashier-weigh'
      }, {
        label: '收银端积分兑换',
        value: 'cashier-point'
      }, {
        label: '管理后台充值',
        value: 'admin-recharge'
      }],
      stationCheckAll: false,
      stationIdChecked: [],
      stationOptions: [],
      isPlatform: 2,
      formData: {
        payChannel: '',
        cnName: '',
        enName: '',
        sysUserId: 0,
        sysUserName: '',
        supportSource: [],
        isShow: 1,
        sort: 0,
        iconImg: '',
        remark: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var stationOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getStationBaseInfoList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 2:
              stationOptions = _context.sent;
              _this2.stationOptions = stationOptions.data.list;

              _this2.onSubmit();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 油站全选
    handleStationCheckAllChange: function handleStationCheckAllChange(val) {
      this.stationIdChecked = val ? this.stationOptions.map(function (item) {
        return item.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.stationOptions.length;

      if (this.stationCheckAll) {
        this.formData.supportStations = '-1';
      } else {
        this.formData.supportStations = '';
      }

      console.log('油站全选', this.formData.supportStations);
    },
    // 油站勾选
    handleCheckedStationChange: function handleCheckedStationChange(value) {
      this.stationCheckAll = value;
      this.formData.supportStations = value.toString();
      console.log('油站勾选', this.formData.supportStations);
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.page = 1;
                _this3.pageSize = 999999;
                _context2.next = 4;
                return _this3.getTableData();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var page, pageSize, fn, table;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                fn = _arguments.length > 2 ? _arguments[2] : undefined;
                _context3.next = 5;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this4.searchInfo));

              case 5:
                table = _context3.sent;

                if (table.code === 0) {
                  _this4.tableData.all = table.data.list;
                  _this4.tableData.show = table.data.list.filter(function (item) {
                    return item.isShow == 1;
                  });
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;
                }

                if (fn) {
                  fn(table);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onReset: function onReset() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.searchInfo = {};
                _context4.next = 3;
                return _this5.onSubmit();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onInputCnname: function onInputCnname() {
      this.formData.remark = this.formData.cnName;
      this.$forceUpdate();
    },
    onChangeIsPlatform: function onChangeIsPlatform() {
      if (this.isPlatform == 1) {
        var maxPayChannel = 0;
        var maxSort = 0;
        this.tableData.all.forEach(function (item) {
          if (item.payChannel >= 2000 && item.payChannel <= 2999 && item.payChannel > maxPayChannel) {
            maxPayChannel = item.payChannel;
          }

          if (item.sort > maxSort) {
            maxSort = item.sort;
          }
        });
        this.formData.payChannel = maxPayChannel + 1;
        this.formData.sort = maxSort + 1;
      }

      if (this.isPlatform == 2) {
        var _maxPayChannel = 0;
        var _maxSort = 0;
        this.tableData.all.forEach(function (item) {
          if (item.payChannel >= 1000 && item.payChannel <= 1999 && item.payChannel > _maxPayChannel) {
            _maxPayChannel = item.payChannel;
          }

          if (item.sort > _maxSort) {
            _maxSort = item.sort;
          }
        });
        this.formData.payChannel = _maxPayChannel + 1;
        this.formData.sort = _maxSort + 1;
      }
    },
    deleteRow: function deleteRow(row) {
      var _this6 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.deleteBairunPayChannel(row);
      }).catch(function (err) {});
    },
    onDelete: function onDelete() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ids = [];

                if (!(_this7.multipleSelection.length === 0)) {
                  _context5.next = 4;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '请选择要删除的数据'
                });

                return _context5.abrupt("return");

              case 4:
                _this7.multipleSelection && _this7.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context5.next = 7;
                return deleteBairunPayChannelByIds({
                  ids: ids
                });

              case 7:
                res = _context5.sent;

                if (res.code === 0) {
                  _this7.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  _this7.onSubmit();
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    updateBairunPayChannel: function updateBairunPayChannel(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, arr;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return findBairunPayChannel({
                  ID: row.ID
                });

              case 2:
                res = _context6.sent;
                _this8.type = 'update';
                console.log(res);

                if (res.code === 0) {
                  res.data.resBairunPayChannel.supportSource = res.data.resBairunPayChannel.supportSource.split(',');
                  _this8.formData = res.data.resBairunPayChannel; // 油站勾选

                  if (_this8.formData.supportStations == '-1') {
                    _this8.handleStationCheckAllChange(true);
                  } else if (_this8.formData.supportStations == '') {} else {
                    arr = res.data.resBairunPayChannel.supportStations.split(',');
                    arr.forEach(function (item) {
                      _this8.stationIdChecked.push(parseInt(item));
                    });
                  }

                  _this8.dialogFormVisible = true;
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.isPlatform = 2;
      this.stationCheckAll = false;
      this.stationIdChecked = [];
      this.formData = {
        payChannel: '',
        cnName: '',
        enName: '',
        sysUserId: 0,
        sysUserName: '',
        supportType: 0,
        isShow: 1,
        sort: 0,
        iconImg: '',
        remark: '',
        supportStations: '',
        supportSource: []
      };
    },
    deleteBairunPayChannel: function deleteBairunPayChannel(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _deleteBairunPayChannel({
                  ID: row.ID
                });

              case 2:
                res = _context7.sent;

                if (res.code === 0) {
                  _this9.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  _this9.onSubmit();
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, param;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                param = JSON.parse(JSON.stringify(_this10.formData));
                param.sort = parseInt(param.sort);
                param.supportSource = param.supportSource.join(',');
                _context8.t0 = _this10.type;
                _context8.next = _context8.t0 === 'create' ? 6 : _context8.t0 === 'update' ? 10 : 14;
                break;

              case 6:
                _context8.next = 8;
                return createBairunPayChannel(param);

              case 8:
                res = _context8.sent;
                return _context8.abrupt("break", 18);

              case 10:
                _context8.next = 12;
                return updateBairunPayChannel(param);

              case 12:
                res = _context8.sent;
                return _context8.abrupt("break", 18);

              case 14:
                _context8.next = 16;
                return createBairunPayChannel(param);

              case 16:
                res = _context8.sent;
                return _context8.abrupt("break", 18);

              case 18:
                if (res.code === 0) {
                  _this10.$message({
                    type: 'success',
                    message: '创建/更改成功'
                  });

                  _this10.closeDialog();

                  _this10.getTableData();
                }

              case 19:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    openDialog: function openDialog() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this11.type = 'create';
                _this11.dialogFormVisible = true;
                _this11.isPlatform = 2;

                _this11.onChangeIsPlatform();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  }
};